<template>
  <div class="patientInfoTitle row flex-center">
   <div class="flex-1">群聊信息</div>
   <div class="addgroup P-Cursor" @click="quickCreateGroup">一键拉群</div>
  </div>
  <!--群聊-->
  <div class="groupInfo">
    <div v-if="groupChatList.length" class="groupList">
      <div
        class="groupItem row flex-center"
        v-for="(groupItem, groupIndex) in displayGroupChatList"
        :key="groupIndex"
      >
        
        <div class="flex-1 groupName">{{ groupItem.name || "未命名的群聊" }}</div>
        <div class="addBtn P-Cursor" 
        v-if="groupItem.isJoin == 1"
        @click="handleGroupActionClick(groupItem)">
          {{ getGroupActionLabel(groupItem.isJoin) }}
        </div>
      </div>
      <!-- 群聊超过预览条数时，先展示前几条，点击后再展示全部 -->
      <div
        v-if="isShowGroupChatLoadMore"
        class="groupChatLoadMore P-Cursor"
        @click="expandGroupChatList"
      >
        点击加载更多
      </div>
    </div>
    <div v-else class="noGroup">客户暂未加入任何群</div>
  </div>
  <div class="patientInfoTitle">添加信息</div>
  <div class="groupInfo" >
    <!-- 添加信息：结构与 PC 端群聊信息组件保持一致，便于统一维护 -->
    <ul class="addition-list">
      <li
        v-for="(additionItem, additionIndex) in additionRecordList"
        :key="additionIndex"
        class="addition-list__row"
      >
        <div class="addition-list__cell left">
          <span class="addition-list__label">添加人：</span>
          <span class="addition-list__value">{{
            additionItem.wecomUserName || additionItem.name 
          }}</span>
        </div>
        <div class="addition-list__cell addition-list__cell--time">
          <span class="addition-list__label">添加时间：</span>
          <span class="addition-list__value">{{
            $filters.formatDateYMD(additionItem.addTime)
          }}</span>
        </div>
      </li>
    </ul>
    <div v-if="additionRecordList.length==0" class="group-list__empty">暂无添加信息</div>
  </div>


  <!--以前的患者信息-->
  <div class="patientInfoTitle">患者信息</div>
  <div class="patientInfo">
    <div class="name row align-bottom">
      <div class="row flex-1">
        <div class="main mr8">{{ patientInfo.patientName }}</div>
        <div class="mr8">{{ patientInfo.sexLabel }}</div>
        <div class="mr8" v-if="patientInfo.age">{{ patientInfo.age }}岁</div>
        <div v-if="patientInfo.contactNo1 != ''">
          <HideMobile
            :phoneNumber="patientInfo.contactNo1"
            :code="patientInfo.contactNo1Encrypted"
            :patientId="patientInfo.id"
        
          >
          </HideMobile>
        </div>
      </div>
      <div class="cancelBtn P-Cursor" @click="UnbindCancellation">取消绑定</div>
    </div>
    <div class="row mt12">
      <div class="patient-left mr8">病历号：</div>
      <div class="patient-rightmain">
        {{ patientInfo.medicalNo }}
      </div>
    </div>

    <div class="row mt12">
      <div class="patient-left mr8">出生日期：</div>
      <div class="patient-rightmain">
        {{ patientInfo.birthday }}
      </div>
    </div>

    <div class="row mt12">
      <div class="patient-left mr8">患者来源：</div>
      <div class="patient-rightmain">
        <span>{{ patientInfo.firstSourceName }}</span
        ><span v-if="patientInfo.secondSourceName">|</span
        >{{ patientInfo.secondSourceName
        }}<span v-if="patientInfo.threeSourceName">|</span
        >{{ patientInfo.threeSourceName }}
      </div>
    </div>

    <div class="row mt8">
      <div class="patient-left mr8 mt2 mr8">患者标签：</div>
      <div class="patient-tag row flex-wrap">
        <div
          class="tagitem"
          v-for="(label, labelindex) in patientInfo.patientLabel"
          :key="labelindex"
        >
          {{ label.labelName || label.labelAbbreviation }}
        </div>
      </div>
    </div>

    <div class="seemore" v-if="!isShowMoreInfo" @click="toggleMoreInfo">
      展开更多信息 <span class="iconfont icon-a-RightArrow"></span>
    </div>
    <div v-show="isShowMoreInfo">
      <!--下面的部分开始隐藏-->
    

    <div class="titleline mt8">口内情况</div>

    <div class="row mt12">
      <div class="patient-left">已治疗：</div>
      <div class="patient-rightmain">
        {{ treatedItems }}
      </div>
    </div>

    <div class="row mt12">
      <div class="patient-left">未治疗：</div>
      <div class="patient-rightmain">
        {{ untreatedItems }}
      </div>
    </div>

    <div class="row mt12">
      <div class="patient-left">需预防：</div>
      <div class="patient-rightmain">
        {{ prophylaxisItems }}
      </div>
    </div>

    <div class="titleline mt8">客户关系</div>

    <div class="row mt8">
      <div class="row mr10 flex-1">
        <div class="patient-left">责任医生：</div>
        <div class="patient-rightmain">
          {{ patientInfo.doctorName }}
        </div>
      </div>

      <div class="row flex-1">
        <div class="patient-left">咨询师：</div>
        <div class="patient-rightmain">
          {{ patientInfo.consultantName }}
        </div>
      </div>
    </div>

    <div class="row mt8">
      <div class="row mr10 flex-1">
        <div class="patient-left">网电营销：</div>
        <div class="patient-rightmain">
          {{ patientInfo.techSupportName }}
        </div>
      </div>

      <div class="row flex-1">
        <div class="patient-left">专属客服：</div>
        <div class="patient-rightmain">
          {{ patientInfo.exclusiveTechSupportName }}
        </div>
      </div>
    </div>

    <div class="titleline mt8">就诊信息</div>

    <div class="row mt8">
      <div class="patient-left">初次就诊：</div>
      <div class="patient-rightmain">
        {{ $filters.formatDateTime(patientInfo.firstVisitTime) }}
        {{ patientInfo.firstVisitDoctorName }}
      </div>
    </div>

    <div class="row mt8">
      <div class="patient-left">上次就诊：</div>
      <div class="patient-rightmain">
        {{ $filters.formatDateTime(patientInfo.lastAppointTime) }}
        {{ patientInfo.lastVisitDoctorName }}
      </div>
    </div>

    <div class="titleline mt8">创建信息</div>

    <div class="row mt8">
      <div class="patient-left">创建日期：</div>
      <div class="patient-rightmain">
        <div>
          {{ $filters.formatDateYMD(patientInfo.createTime) }}
          {{ patientInfo.createEmployeeName }}
        </div>
      </div>
    </div>

    <div class="row mt8">
      <div class="patient-left">创建门店：</div>
      <div class="patient-rightmain">
        <div>
          {{ patientInfo.clinicName }}
        </div>
      </div>
    </div>

    <div class="seemore"  @click="toggleMoreInfo">
       收起<span class="iconfont icon-a-RightArrow up"></span>
    </div>

      <!-- <div class="cancelBtn P-Cursor" @click="UnbindCancellation">取消绑定</div> -->
    </div>
  </div>
</template>
<script>
import { showDialog } from "vant";
import { userStore } from "@/store/user.js";
import {
  UnlinkWeChatCustomer,
  queryWeChatPatientDetails,
  getPatientOralConditions,
} from "@/api/patient.js";
import {
  getExternalUserGroupChatList,
} from "@/api/group.js";
import { getAllExternalContactsByUserId } from "@/api/pc/clueManagement.js";
import { loadingStore } from "@/store/loading.js";
import HideMobile from "@/components/publick/hideMobile.vue";
import { useRouter } from "vue-router";

const GROUP_JOIN_STATUS = {
  NOT_JOINED: 0,
  JOINED: 1,
};

const GROUP_ACTION_LABEL_MAP = {
  [GROUP_JOIN_STATUS.NOT_JOINED]: "加入",
  [GROUP_JOIN_STATUS.JOINED]: "聊天",
};

/** 群聊列表默认预览展示条数（超出后需点击加载更多） */
const GROUP_CHAT_PREVIEW_COUNT = 5;

export default {
  name: "patientInfo",
  props: {
    patientId: {
      type: String, // or the appropriate type
      required: true, // or false based on your requirement
    },
  },
  components: {
    HideMobile,
  },
  data: function () {
    return {
      patientInfo: {},
      prophylaxisItems: "", // 存储预防项目的字符串
      treatedItems: "", // 存储已治疗项目的字符串
      untreatedItems: "", // 存储未治疗项目的字符串
      isShowMoreInfo: false, // 是否展开更多信息
      groupChatList: [], // 患者群聊列表（接口完整数据，逻辑与展示分离）
      /** 是否已展开显示全部群聊（每次重新拉取列表会重置为 false） */
      isGroupChatListExpanded: false,
      additionRecordList: [], // 添加信息列表
    };
  },
  computed: {
    /** 列表渲染用：未展开时最多预览 GROUP_CHAT_PREVIEW_COUNT 条 */
    displayGroupChatList() {
      const listData = this.groupChatList;
      if (!Array.isArray(listData) || !listData.length) {
        return [];
      }
      if (
        this.isGroupChatListExpanded ||
        listData.length <= GROUP_CHAT_PREVIEW_COUNT
      ) {
        return listData;
      }
      return listData.slice(0, GROUP_CHAT_PREVIEW_COUNT);
      
    },
    /** 是否显示「点击加载更多」 */
    isShowGroupChatLoadMore() {
      
      return (
        Array.isArray(this.groupChatList) &&
        this.groupChatList.length > GROUP_CHAT_PREVIEW_COUNT &&
        !this.isGroupChatListExpanded
      );
    },
  },
  setup() {
    const loading = loadingStore();
    const router = useRouter();
    return {
      loading,
      router,
    };
  },
  mounted: function () {
    this.getParentInfo();
    //获取口内情况
    this.getOralConditions();
    this.getGroupChatList();
    this.getAddContactList();
  },
  methods: {
    getGroupActionLabel(isJoinStatus) {
      return (
        GROUP_ACTION_LABEL_MAP[isJoinStatus] ||
        GROUP_ACTION_LABEL_MAP[GROUP_JOIN_STATUS.NOT_JOINED]
      );
    },
    getGroupChatList() {
      const userInfoStore = userStore();
      getExternalUserGroupChatList({
        corpId: userInfoStore.corpId,
        patientId: this.patientId,
      }).then((res) => {
        const { data } = res.data || {};
        this.groupChatList = Array.isArray(data) ? data : [];
        // 新数据回到「仅预览」状态，避免切换患者/刷新后仍停留在展开态
        this.isGroupChatListExpanded = false;
      });
    },
    /** 展开群聊列表，展示剩余条目 */
    expandGroupChatList() {
      this.isGroupChatListExpanded = true;
    },
    // 统一处理 joinGroup 失败提示，与 PC 端群聊信息组件保持一致
    getJoinGroupErrorMessage(error) {
      const errMsgValue = error?.errMsg || "";
      if (String(errMsgValue).includes("unsupported chat")) {
        return "未找到该群聊天";
      }
      return error?.errMsg || error?.message || "打开群聊失败";
    },
    getAddContactList() {
      const userInfoStore = userStore();
      if (!userInfoStore.cusId) {
        this.additionRecordList = [];
        return;
      }
      getAllExternalContactsByUserId({
        externalUserId: userInfoStore.cusId,
      }).then((res) => {
        const {data} = res.data;
        this.additionRecordList = data.addDetails;
        
      });
    },
    async handleGroupActionClick(groupItem) {
      const userInfoStore = userStore();


      if (
        Number(groupItem?.isJoin) === GROUP_JOIN_STATUS.JOINED &&
        groupItem?.chatId
      ) {
        try {
          await userInfoStore.joinGroup({
            chatId: groupItem.chatId
          });
        } catch (error) {
          this.$message.warning(this.getJoinGroupErrorMessage(error));
        }
      }
    },
    toggleMoreInfo() {
      // 切换更多患者信息区的显示/收起状态
      const moreInfoVisible = !this.isShowMoreInfo;
      this.isShowMoreInfo = moreInfoVisible;
    },
    UnbindCancellation() {
      let that = this;
      showDialog({
        title: "取消绑定",
        message: "确认取消绑定用户信息吗？",
        showCancelButton: true,
        confirmButtonColor: "#28B8C3",
      })
        .then(() => {
          // on close
          this.unBindSubmit();
        })
        .catch(() => {
          // on cancel
        });
    },
    unBindSubmit() {
      let that = this;
      const aloginStoreuth = userStore();
      that.loading.showLoading();
      UnlinkWeChatCustomer({
        corpId: aloginStoreuth.corpId,
        cusId: aloginStoreuth.cusId,
      })
        .then((res) => {
          that.$emit("unBindSuccess");
          that.loading.hideLoading();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getParentInfo() {
      //获取客户的信息
      let that = this;
      //获取患者信息
      let subdata = {
        patientId: that.patientId,
      };
      that.loading.showLoading();
      queryWeChatPatientDetails(subdata).then((res) => {
        that.loading.hideLoading();
        let { data } = res.data;

        console.log(data);

        that.patientInfo = data;
      });
    },
    getOralConditions() {
      let that = this;
      //获取患者信息
      let subdata = {
        patientId: that.patientId,
      };
      getPatientOralConditions(subdata).then((res) => {
        let { data } = res.data;
        let { prophylaxisItems, treatedItems, untreatedItems } = data;
        that.prophylaxisItems = prophylaxisItems;
        that.treatedItems = treatedItems;
        that.untreatedItems = untreatedItems;
      });
    },
    quickCreateGroup() {
      // 跳转到建群第一步，携带患者ID用于后续建群操作
      let user = userStore();
      let cusId = user.cusId;


      this.router.push({
        name: "createGroupStep1",
        query: {
          patientId: this.patientInfo.id,
          externalUserId: cusId,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.name {
  color: #666;

  .main {
    color: #333;
    font-size: 0.313rem;
    font-weight: bold;
  }
}

.patientInfoTitle{
  text-align: left;
  padding: .167rem 0rem;
}

/**患者资料**/
.patientInfo {
  background-color: #fff;
  padding: 0.25rem 0.208rem;
  box-sizing: border-box;
  margin-bottom: 0.25rem;
}
.patient-left {
  min-width: 1.542rem;
  color: #666666;
}

.patient-rightmain {
  color: #333;
  text-align: left;
  word-break: break-all;
}

.patient-tag {
  .tagitem {
    padding: 0.083rem 0.167rem;
    font-size: 0.25rem;
    background-color: #f5f5f5;
    color: #333;
    border-radius: 999px;
    margin-right: 0.167rem;
    margin-bottom: 0.083rem;
  }
}

.titleline {
  color: #333;
  font-size: 0.292rem;
  text-align: left;
  font-weight: 800;
}

.seemore {
  font-size: 0.292rem;
  color: #666;
  margin-top: 0.208rem;
  cursor: pointer;
  .icon-a-RightArrow{
    display: inline-block;
    font-size: .25rem;
    vertical-align:0.043rem;
    margin-left: .083rem;
    position: relative;
    transform: rotate(90deg);
    &.up{
      transform: rotate(-90deg);
      vertical-align:-0;
    }
  }
}

.cancelBtn {
  // height: 0.833rem;
  // line-height: 0.833rem;
  // background-color: #eaf8f9;
  // color: #28b8c3;
  // font-size: 0.271rem;
  // text-align: center;
  // border: 0.021rem solid #bfeaed;
  // border-radius: 0.083rem;
  // margin-top: 0.625rem;
  padding: .083rem .208rem;
  font-size: .271rem;
  color: #28b8c3;
}

.addgroup{
  color: #28b8c3;
  padding: .083rem .208rem;
  font-size: .271rem;
}

.groupInfo{
  background-color: #fff;
  padding: .167rem .208rem;
  box-sizing: border-box;
  margin-bottom: 0.25rem;
  border-radius: .125rem;
  .noGroup{
     font-size:.271rem;
     color: #666; 
  }
  .groupList{
    text-align: left;

    // 对齐建群页 joined-list 的列表行距：保持行内留白和视觉分割
    .groupItem{
      padding: .167rem 0; // 8px 0

      // 两个群聊项之间增加顶部下划线，形成清晰分隔
      & + .groupItem {
        border-top: .021rem solid #f5f5f5; // 1px
      }

      .groupName{
        font-size: .271rem;
        color: #333;
      }
      .addBtn{
        font-size: .271rem;
        color: #28b8c3;
        margin-left: .25rem;
        cursor: pointer;
      }
    }

    .groupChatLoadMore {
      margin-top: 0;
      padding: .167rem 0 .042rem;
      font-size: 0.292rem;
      color: #666;
      text-align: center;
      line-height: 1.4;
      border-top: .021rem solid #f5f5f5; // 1px
      // 与列表行保持一致的视觉节奏
    }
  }

  .addition-list {
    margin: 0;
    padding: 0.083rem 0 0;
    list-style: none;
    text-align: left;
  }

  .addition-list__row {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 0.167rem;
    padding: 0.083rem 0;
    border-bottom: 0.021rem solid #f0f0f0;
    .left{
      width: 45%;
    }
    &:last-child {
      border-bottom: none;
    }
  }

  .addition-list__cell {
    display: flex;
    flex-direction: row;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 0.042rem;
    font-size: 0.271rem;
    line-height: 0.458rem;
  }

  .addition-list__cell--time {
    flex-shrink: 0;
    text-align: right;
  }

  .addition-list__label {
    color: #999;
  }

  .addition-list__value {
    color: #333;
  }
}

</style>
